(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = this.querySelectorAll('[data-control]');

      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });

      this.calcHeight();

      [
        'shopify:section:load',
        'load',
        'resize'
      ].forEach((event) => {
        window.addEventListener(event, this.calcHeight.bind(this));
      });
    }

    connectedCallback() {
      this.slider = new Splide(this, {
        type: Number(this.dataset.slidesCount) > 1 ? 'loop' : 'slide',
        rewind: false,
        drag: Number(this.dataset.slidesCount) > 1,
        pagination: true,
        waitForTransition: false,
        arrows: false,
        speed: 800,
        easing: 'ease-in-out',
        autoplay: JSON.parse(this.dataset.autoplay),
        interval: Number(this.dataset.autoplayInterval)
      }).mount();
    }

    onControlClick(event) {
      event.preventDefault();

      if (this.slider === {}) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.slider.go(action);
    }

    calcHeight() {
      const announcementBar = document.querySelector('#shopify-section-announcement-bar:not(#shopify-section-header + #shopify-section-announcement-bar)');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

      const headerOffset =
        announcementBarHeight +
        document.querySelector('#shopify-section-header').offsetHeight;

      this.querySelectorAll('.hero__block').forEach((element) => {
        element.style.height = window.innerWidth > 989
          ? 'auto'
          : `calc(var(--viewport-height) - ${headerOffset}px)`;
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
